import ApiException from "@rmp/core/exceptions/apiException";

export default class ServerUnavailableException extends ApiException {
	constructor(public readonly url: string) {
		super(`ServerUnavailableException: ${url}`);
	}
}
